export const baseUrl = 'http://localhost:8001'
export const host = 'https://dev-chat-app.duckdns.org/chat'
